import {GetterTree} from "vuex";
import {RootState} from "@/store/types";
import {BeruGetters, BeruState} from "@/store/beru/types";

const getters: GetterTree<BeruState, RootState> & BeruGetters = {
  beruRates: state => state.beru_rates,
  exchangeFree: state => state.exchange_free,
  exchangeTaken: state => state.exchange_taken,
  exchangeFreeMeta: state => state.exchange_free_meta,
  exchangeTakenMeta: state => state.exchange_taken_meta,
  closeReasons: state => state.close_reasons,
  closeTypeReasons: state => state.close_type_reasons,
  beruDetail: state => state.beru_detail,
}

export default getters